import { IonButton, IonHeader, IonModal, IonSpinner, IonToolbar } from "@ionic/react";
import { useContext, useState } from "react";
import { APIService } from "../network/APIService";
import AppContext from "../providers/AppContext";
import { Group } from "../utils/Interfaces";

const DeleteGroupModal = ({
  group,
  isOpen,
  handleModalDismiss,
}: {
  group: Group | undefined;
  isOpen: boolean;
  handleModalDismiss: (deletedGroup: boolean) => void;
}) => {
  const appContext = useContext(AppContext);
  const [deletingGroup, setDeletingGroup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleDeleteGroup = async () => {
    setErrorMessage("");
    setDeletingGroup(true);
    const deletedGroupSuccessfully = await APIService.deleteGroup(appContext.jwt, group?.id!);
    setDeletingGroup(false);

    if (deletedGroupSuccessfully) {
      handleModalDismiss(true);
    } else {
      // show error message
      setErrorMessage("Failed to delete the the group. Please restart your browswer and try again.");
    }
  };

  return (
    <IonModal backdropDismiss={false} isOpen={isOpen} className="deleteModal">
      <IonHeader>
        <IonToolbar>
          <div className="modalToolbarContent">
            <div className="modalToolbarSides" />
            <p>Delete User</p>
            {deletingGroup ? (
              <div className="modalToolbarSides">
                <IonSpinner name="bubbles" />
              </div>
            ) : (
              <div className="modalToolbarSides" />
            )}
          </div>
        </IonToolbar>
      </IonHeader>
      <div className="modalMainContent">
        <p className="modalConfirmationText">
          Are you sure you want to delete "<span>{group?.name}</span>"?
        </p>
        {errorMessage && <p className="modalErrMessage">{errorMessage}</p>}
      </div>
      <div className="modalFooterButtonsContainer">
        <IonButton
          disabled={deletingGroup}
          className="cancelBtn"
          onClick={() => {
            setErrorMessage("");
            handleModalDismiss(false);
          }}
        >
          Cancel
        </IonButton>
        <IonButton disabled={deletingGroup} className="deletePillBtn" onClick={handleDeleteGroup}>
          Delete Group
        </IonButton>
      </div>
    </IonModal>
  );
};

export default DeleteGroupModal;
